import axios from 'axios';
import { remove } from 'lodash';

import { API_URL } from '../config';
import * as types from '../constants/ActionTypes';
import { handleUnauthorizedError } from '../lib/heartBeat';

export function getHomeworkList(limit = 0, favouriteOnly = false, searchPage = 0) {
    searchPage++;
    const url = `${API_URL}/cv/homework/teacher`;
    return async dispatch => {
        dispatch({
            type: searchPage === 1 ? types.GET_HOMEWORK_LIST : types.GET_MORE_HOMEWORK_LIST,
            payload: {
                favouriteOnly,
                page: searchPage
            }
        });
        try {
            let paramArray = [];
            paramArray.push(`limit=${limit}`);
            paramArray.push(`favourite=${favouriteOnly}`);
            paramArray.push(`page=${searchPage}`);
            paramArray.push(`etag=${Math.random() * 1000}`);

            const {
                data: { data, totalCount }
            } = await axios.get(`${url}?${paramArray.join('&')}`);
            dispatch({
                type: searchPage === 1 ? types.GET_HOMEWORK_LIST_SUCCESS : types.GET_MORE_HOMEWORK_LIST_SUCCESS,
                payload: {
                    result: data,
                    searchPage,
                    totalCount
                }
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({
                type: searchPage === 1 ? types.GET_HOMEWORK_LIST_FAILURE : types.GET_MORE_HOMEWORK_LIST_FAILURE,
                error: e
            });
        }
    };
}

export function deleteUserHomework(homeworkList, homeworkId) {
    const url = `${API_URL}/cat/homework/${homeworkId}`;
    return async dispatch => {
        dispatch({ type: types.DELETE_HOMEWORK });
        try {
            await axios.delete(url);
            remove(homeworkList, n => n._id === homeworkId);
            dispatch({
                type: types.DELETE_HOMEWORK_SUCCESS,
                homeworkList: homeworkList
            });
        } catch (e) {
            handleUnauthorizedError(e, dispatch);
            dispatch({ type: types.DELETE_HOMEWORK_FAILURE });
        }
    };
}
